// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/src/Layout.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/src/Layout.tsx");
  import.meta.hot.lastModified = "1744085769114.8093";
}
// REMIX HMR END

import * as React from "react";
import { useState } from "react";
import { useMediaQuery, useTheme, Switch, FormControlLabel, ListItemButton, Menu, MenuItem, IconButton, AppBar, Toolbar, Drawer, List, ListItem, ListItemIcon, ListItemText, CssBaseline, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useThemeToggle } from "./ThemeContext";
import { Form, Link as RemixLink } from "@remix-run/react";
const drawerWidth = 200;
const Layout = ({
  children
}) => {
  _s();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const {
    toggleTheme
  } = useThemeToggle();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(!drawerOpen);
  };
  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const drawer = <div>
      <Toolbar />
      <List>
        {[{
        text: "Dashboard",
        icon: <DashboardIcon />,
        link: "/"
      }, {
        text: "Products",
        icon: <InventoryIcon />,
        link: "/products"
      }, {
        text: "Orders",
        icon: <ShoppingCartIcon />,
        link: "/orders"
      }, {
        text: "Customers",
        icon: <PeopleIcon />,
        link: "/customers"
      }, {
        text: "Suppliers",
        icon: <LocalShippingIcon />,
        link: "/suppliers"
      }].map(item => <RemixLink to={item.link} style={{
        textDecoration: "none",
        color: "inherit",
        display: "block"
      }} key={item.text}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} sx={{
            display: {
              sm: drawerOpen ? "block" : "none"
            }
          }} />
            </ListItemButton>
          </RemixLink>)}
      </List>
      <Box sx={{
      flexGrow: 1
    }} />
      {isMobile && <List>
          <ListItemButton>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" sx={{
          display: {
            sm: drawerOpen ? "block" : "none"
          }
        }} />
          </ListItemButton>
          <ListItemButton>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary="Profile" sx={{
          display: {
            sm: drawerOpen ? "block" : "none"
          }
        }} />
          </ListItemButton>
          <ListItem>
            <FormControlLabel control={<Switch checked={theme.palette.mode === "dark"} onChange={toggleTheme} />} label="Dark Mode" />
          </ListItem>
        </List>}
    </div>;
  return <Box sx={{
    display: "flex"
  }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{
      zIndex: theme => theme.zIndex.drawer + 1
    }}>
        <Toolbar>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{
          mr: 2,
          display: {
            sm: "none"
          }
        }}>
            <MenuIcon />
          </IconButton>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerOpen} sx={{
          mr: 2,
          display: {
            xs: "none",
            sm: "block"
          }
        }}>
            <MenuIcon />
          </IconButton>
          <Box component="div" sx={{
          flexGrow: 1
        }}>
            GoPiscine ERP
          </Box>
          {!isMobile && <>
              <FormControlLabel control={<Switch checked={theme.palette.mode === "dark"} onChange={toggleTheme} />} label="Dark Mode" />
              <IconButton color="inherit" aria-controls="profile-menu" aria-haspopup="true" onClick={handleMenuClick}>
                <AccountCircleIcon />
              </IconButton>
              <Menu id="profile-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem component="a" href="#" onClick={handleMenuClose}>
                  My Profile
                </MenuItem>
                {/* Logout via Form submission */}
                <Form method="post" action="/logout">
                  <MenuItem component="button" type="submit" onClick={handleMenuClose}>
                    Logout
                  </MenuItem>
                </Form>
              </Menu>
            </>}
        </Toolbar>
      </AppBar>
      <Box component="nav" sx={{
      width: {
        sm: drawerOpen ? drawerWidth : "60px"
      },
      flexShrink: {
        sm: 0
      }
    }} aria-label="mailbox folders">
        <Drawer variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{
        keepMounted: true // Better open performance on mobile.
      }} sx={{
        display: {
          xs: "block",
          sm: "none"
        },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: drawerWidth
        }
      }}>
          {drawer}
        </Drawer>
        <Drawer variant="permanent" open={drawerOpen} onClose={handleDrawerOpen} sx={{
        display: {
          xs: "none",
          sm: "block"
        },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: drawerOpen ? drawerWidth : "60px"
        }
      }}>
          {drawer}
        </Drawer>
      </Box>
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3
    }}>
        <Toolbar />
        <Box>{children}</Box>
      </Box>
    </Box>;
};
_s(Layout, "5805M+6fHh+T/zDL0y5dEvyAzV4=", false, function () {
  return [useTheme, useThemeToggle, useMediaQuery];
});
_c = Layout;
export default Layout;
var _c;
$RefreshReg$(_c, "Layout");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;